var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWelcomeBlobMd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 306,
    viewBox: "0 0 313 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.335 192.531C145.323 231.497 82.4796 275.857 24.5171 265.943C-33.4978 256.326 -86.5795 192.137 -92.528 130.133C-98.4765 68.1288 -57.2394 8.01204 -13.0703 -35.047C30.7433 -77.8625 77.2381 -103.971 117.836 -100.182C158.381 -96.0955 193.03 -62.1119 226.047 -25.9656C258.76 10.1273 289.539 48.3294 286.337 84.2156C282.832 120.048 245.651 153.619 195.335 192.531Z",
    fill: "#E8E8D8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWelcomeBlobMd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WelcomeBlobMd.1c7766c3d77b4fdb0008cca74a6d11ef.svg";